import React from 'react';
import { Route, Switch, withRouter, RouteComponentProps } from 'react-router-dom';

import AttributesList from '~src/modules/attributes/components/list/AttributesList';
import AttributesAdd from '~src/modules/attributes/components/add/AttributeAdd';
import AttributeDetails from '~src/modules/attributes/components/details/AttributeDetails';
import PageNotFound from '~src/shared/errorPages/PageNotFound';
import { itemIdMatch } from '~src/constants';

interface OwnProps {
  isAuthenticated: boolean;
}

type Props = OwnProps & RouteComponentProps<any>;

class Attributes extends React.Component<Props> {
  static defaultProps = {
    isAuthenticated: false,
  };

  render() {
    const { match } = this.props;
    return (
      <Switch>
        <Route exact strict path={match.url} component={AttributesList} />
        <Route exact strict path={`${match.url}/add`} component={AttributesAdd} />
        <Route exact strict path={`${match.url}/:attributeId(${itemIdMatch})`} component={AttributeDetails} />
        <PageNotFound {...this.props} />
      </Switch>
    );
  }
}

const AttributesR = withRouter(Attributes);

export default AttributesR;
